<template>
  <div class="pro-venue-moments">
    <span class="pro-venue-moments__title"> Moments </span>
    <span class="pro-venue-moments__subtitle" v-if="relatedMoments.length > 0" @click="showMoreMoments()">
      {{ $t("general.header.dropdown.showAll") }}
    </span>
    <div class="pro-venue-moments__carousel">
      <Carousel
        v-if="relatedMoments.length > 0"
        v-bind="config"
        @mousedown="onMouseDown"
        @mousemove="onMouseMove"
        @mouseup="onMouseUp"
      >
        <Slide v-for="moment in relatedMoments" :key="moment.id">
          <pro-venue-moment-card :selected-moment="moment"></pro-venue-moment-card>
        </Slide>
      </Carousel>
      <div v-else class="no-events">
        <span>
          {{ $t("provenue.noMoments") }}
        </span>
      </div>
    </div>
  </div>
  <modal-profiles
    v-if="showModal"
    title="Moments"
    type="medium"
    :gradient="momentStore.moments.length > pageSize"
    :total-items="momentStore.moments.length"
    :page="currentPage"
    :items-per-page="pageSize"
    @next-page="nextPage()"
    @close="closeMomentsModal()"
  >
    <template #modalProfile>
      <section class="flex flex-wrap gap-[14px] relative">
        <div v-for="moment in momentStore.moments" :key="moment.id">
          <pro-venue-moment-card :selected-moment="moment"></pro-venue-moment-card>
        </div>
      </section>
    </template>
  </modal-profiles>
</template>

<script setup>
import { Carousel, Slide } from "vue3-carousel";
import ProVenueMomentCard from "./ProVenueMomentCard.vue";
import ModalProfiles from "../../modals/ModalProfiles.vue";
import { ref, watch } from "vue";
import { useMomentStore } from "@/stores/modules/moment";
import { useVenueStore } from "@/stores/modules/venue";

const momentStore = useMomentStore();
const venueStore = useVenueStore();

defineProps({
  relatedMoments: {
    type: Array,
    default: () => [],
  },
});

const showModal = ref(false);
const currentPage = ref(0);
const pageSize = ref(20);
const config = ref({
  itemsToShow: 2,
  snapAlign: "center",
  breakpoints: {
    // 200px and up
    200: {
      itemsToShow: 1.8,
      snapAlign: "center",
    },
    // 300px and up
    300: {
      itemsToShow: 1.5,
      snapAlign: "center",
    },
    // 500px and up
    500: {
      itemsToShow: 2.5,
      snapAlign: "start",
    },
    // 800px and up
    800: {
      itemsToShow: 3.5,
      snapAlign: "start",
    },
  },
});

watch(
  currentPage,
  (newCurrent) => {
    momentStore.moments.page = newCurrent;
    if (currentPage.value > 1) {
      momentStore.getMoments({ tag_slug: venueStore.details.slug });
    } else if (currentPage.value === 1) {
      momentStore.moments.page_size = 10;
      momentStore.getMoments({ tag_slug: venueStore.details.slug });
    }
  },
  { immediate: true }
);

const showMoreMoments = () => {
  momentStore.moments.page_size = pageSize.value;
  showModal.value = true;
  momentStore.getMoments({
    tag_slug: venueStore.details.slug,
    page_size: pageSize.value,
  });
};

const nextPage = () => {
  currentPage.value++;
};

const closeMomentsModal = () => {
  showModal.value = false;
  currentPage.value = 1;
};
</script>

<style lang="scss" scoped>
.pro-venue-moments {
  height: 430px;
  background: #000214;
  border-radius: 10px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  &__title {
    font-size: 1.25rem;
  }
  &__subtitle {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    flex-wrap: wrap;
    color: #2effec;
    cursor: pointer;
    font-size: 14px;
  }
  &__carousel {
    margin-top: 1.625rem;
    height: 100%;
    & > .no-events {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>
